import { FormEvent, useState } from "react";
import { Link, router, Head } from "@inertiajs/react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface ForgotPasswordProps {
  errors?: {
    email?: string;
  };
}

export default function ForgotPassword({ errors = {} }: ForgotPasswordProps) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);

    router.post(
      "/users/password",
      {
        user: {
          email,
        },
      },
      {
        onFinish: () => setLoading(false),
      }
    );
  };

  return (
    <>
      <Head title="نسيت كلمة المرور" />
      <Card>
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">نسيت كلمة المرور؟</CardTitle>
          <CardDescription className="text-center">
            أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة تعيين كلمة المرور
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">البريد الإلكتروني</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoFocus
              />
              {errors?.email && <p className="text-sm text-destructive">{errors.email}</p>}
            </div>

            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "جاري الإرسال..." : "إرسال رابط إعادة التعيين"}
            </Button>

            <div className="text-center text-sm">
              <Link href="/users/sign_in" className="text-muted-foreground hover:text-primary">
                العودة لتسجيل الدخول
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </>
  );
}
